import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    id: "modal-edicao-meu-perfil",
    class: "modal fade",
    role: "dialog",
    "aria-hidden": "true"
};
const _hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const _hoisted_3 = { class: "modal-content" };
const _hoisted_4 = { class: "modal-header" };
const _hoisted_5 = { class: "row" };
const _hoisted_6 = { class: "col-12" };
const _hoisted_7 = { class: "modal-title font-weight-400" };
const _hoisted_8 = {
    key: 0,
    class: "text-left pull-left mt-1"
};
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("a", {
    href: "ajudas/2/artigos",
    target: "_blank",
    class: "btn-link text-2"
}, "Clique aqui para saber tudo sobre o saque.", -1);
const _hoisted_10 = [
    _hoisted_9
];
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("button", {
    type: "button",
    class: "close font-weight-400",
    "data-dismiss": "modal",
    "aria-label": "Close"
}, [
    /*#__PURE__*/ _createElementVNode("span", { "aria-hidden": "true" }, "×")
], -1);
const _hoisted_12 = { class: "modal-body p-4" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("div", { style: { "position": "absolute", "left": "-100000px" } }, [
    /*#__PURE__*/ _createElementVNode("input", {
        type: "text",
        name: "prevent_autocomplete_u"
    }),
    /*#__PURE__*/ _createElementVNode("input", {
        type: "password",
        name: "prevent_autocomplete_p"
    })
], -1);
const _hoisted_14 = { key: 0 };
const _hoisted_15 = { class: "row" };
const _hoisted_16 = { class: "col-12" };
const _hoisted_17 = { class: "form-group" };
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Tipo de Conta", -1);
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("option", { value: "" }, null, -1);
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("option", { value: "F" }, "Pessoa Física", -1);
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("option", { value: "J" }, "Pessoa Jurídica", -1);
const _hoisted_22 = [
    _hoisted_19,
    _hoisted_20,
    _hoisted_21
];
const _hoisted_23 = {
    key: 0,
    class: "row"
};
const _hoisted_24 = { class: "col-12" };
const _hoisted_25 = { class: "form-group" };
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Nome Completo", -1);
const _hoisted_27 = ["disabled"];
const _hoisted_28 = { class: "col-12 col-12" };
const _hoisted_29 = { class: "form-group" };
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "CPF", -1);
const _hoisted_31 = { class: "col-6" };
const _hoisted_32 = { class: "form-group" };
const _hoisted_33 = /*#__PURE__*/ _createElementVNode("label", {
    for: "birthDate",
    class: "requerido"
}, "Data de Nascimento", -1);
const _hoisted_34 = { class: "position-relative" };
const _hoisted_35 = { class: "col-6" };
const _hoisted_36 = { class: "form-group" };
const _hoisted_37 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Celular", -1);
const _hoisted_38 = { class: "col-12" };
const _hoisted_39 = { class: "form-group" };
const _hoisted_40 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "E-mail", -1);
const _hoisted_41 = /*#__PURE__*/ _createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "alert alert-danger" }, " Atenção! Se você trocar de e-mail será necessário confirmar o novo e-mail clicando no link que enviaremos para você. ")
], -1);
const _hoisted_42 = { class: "col-12" };
const _hoisted_43 = { class: "form-check custom-control custom-checkbox" };
const _hoisted_44 = /*#__PURE__*/ _createElementVNode("label", {
    class: "custom-control-label",
    for: "aceita_receber_emails_marketing"
}, "Aceito receber notícias, promoções e novidades da Campanha do Bem.", -1);
const _hoisted_45 = {
    key: 1,
    class: "row"
};
const _hoisted_46 = { class: "col-12" };
const _hoisted_47 = { class: "form-group" };
const _hoisted_48 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Nome Fantasia", -1);
const _hoisted_49 = ["disabled"];
const _hoisted_50 = { class: "col-12" };
const _hoisted_51 = { class: "form-group" };
const _hoisted_52 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Razão Social", -1);
const _hoisted_53 = ["disabled"];
const _hoisted_54 = { class: "col-12 col-6" };
const _hoisted_55 = { class: "form-group" };
const _hoisted_56 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "CNPJ", -1);
const _hoisted_57 = { class: "col-12 col-6" };
const _hoisted_58 = { class: "form-group" };
const _hoisted_59 = /*#__PURE__*/ _createElementVNode("label", null, "Inscrição Estadual", -1);
const _hoisted_60 = ["disabled"];
const _hoisted_61 = {
    key: 2,
    class: "row"
};
const _hoisted_62 = /*#__PURE__*/ _createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-5 font-weight-400 mt-3" }, " Responsável pela Empresa "),
    /*#__PURE__*/ _createElementVNode("hr")
], -1);
const _hoisted_63 = { class: "col-12" };
const _hoisted_64 = { class: "form-group" };
const _hoisted_65 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Nome Completo Responsável", -1);
const _hoisted_66 = ["disabled"];
const _hoisted_67 = { class: "col-12" };
const _hoisted_68 = { class: "form-group" };
const _hoisted_69 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "CPF do Responsável", -1);
const _hoisted_70 = { class: "col-6" };
const _hoisted_71 = { class: "form-group" };
const _hoisted_72 = /*#__PURE__*/ _createElementVNode("label", {
    for: "birthDate",
    class: "requerido"
}, "Data de Nascimento", -1);
const _hoisted_73 = { class: "position-relative" };
const _hoisted_74 = { class: "col-6" };
const _hoisted_75 = { class: "form-group" };
const _hoisted_76 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Celular", -1);
const _hoisted_77 = { class: "col-12" };
const _hoisted_78 = { class: "form-group" };
const _hoisted_79 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "E-mail", -1);
const _hoisted_80 = /*#__PURE__*/ _createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "alert alert-danger" }, " Atenção! Se você trocar de e-mail será necessário confirmar o novo e-mail. Enviaremos um link para você reativar sua conta. ")
], -1);
const _hoisted_81 = { class: "col-12" };
const _hoisted_82 = { class: "form-check custom-control custom-checkbox" };
const _hoisted_83 = /*#__PURE__*/ _createElementVNode("label", {
    class: "custom-control-label",
    for: "aceita_receber_emails_marketing"
}, "Aceito receber notícias, promoções e novidades da Campanha do Bem.", -1);
const _hoisted_84 = { key: 1 };
const _hoisted_85 = { class: "text-danger" };
const _hoisted_86 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-info-circle" }, null, -1);
const _hoisted_87 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_88 = /*#__PURE__*/ _createElementVNode("span", { class: "text-danger" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-info-circle" }),
    /*#__PURE__*/ _createTextVNode(" NÃO fazemos depósitos em CONTA POUPANÇA. ")
], -1);
const _hoisted_89 = { class: "row" };
const _hoisted_90 = { class: "col-12 mt-3" };
const _hoisted_91 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Banco", -1);
const _hoisted_92 = { id: "banco_container" };
const _hoisted_93 = { class: "row" };
const _hoisted_94 = { class: "col-6" };
const _hoisted_95 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Agência", -1);
const _hoisted_96 = ["disabled"];
const _hoisted_97 = /*#__PURE__*/ _createElementVNode("small", { class: "helper-abaixo-input" }, [
    /*#__PURE__*/ _createTextVNode(" Ex: "),
    /*#__PURE__*/ _createElementVNode("b", null, "0001"),
    /*#__PURE__*/ _createTextVNode(" / "),
    /*#__PURE__*/ _createElementVNode("b", null, "215"),
    /*#__PURE__*/ _createTextVNode(" / "),
    /*#__PURE__*/ _createElementVNode("b", null, "1234-"),
    /*#__PURE__*/ _createElementVNode("span", {
        class: "text-danger",
        style: { "text-decoration": "line-through" }
    }, " 2 ")
], -1);
const _hoisted_98 = { class: "col-6" };
const _hoisted_99 = /*#__PURE__*/ _createElementVNode("label", null, [
    /*#__PURE__*/ _createTextVNode("Agência - Dígito "),
    /*#__PURE__*/ _createElementVNode("small", null, "(Se houver)")
], -1);
const _hoisted_100 = ["disabled"];
const _hoisted_101 = /*#__PURE__*/ _createElementVNode("small", { class: "helper-abaixo-input" }, [
    /*#__PURE__*/ _createTextVNode(" Ex: "),
    /*#__PURE__*/ _createElementVNode("span", {
        class: "text-danger",
        style: { "text-decoration": "line-through" }
    }, " 1234 "),
    /*#__PURE__*/ _createElementVNode("b", null, "-2")
], -1);
const _hoisted_102 = { class: "row" };
const _hoisted_103 = { class: "col-6" };
const _hoisted_104 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Conta", -1);
const _hoisted_105 = ["disabled"];
const _hoisted_106 = /*#__PURE__*/ _createElementVNode("small", { class: "helper-abaixo-input" }, [
    /*#__PURE__*/ _createTextVNode(" Ex: "),
    /*#__PURE__*/ _createElementVNode("b", null, "123456-"),
    /*#__PURE__*/ _createElementVNode("span", {
        class: "text-danger",
        style: { "text-decoration": "line-through" }
    }, " 2 ")
], -1);
const _hoisted_107 = { class: "col-6" };
const _hoisted_108 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Conta - Dígito", -1);
const _hoisted_109 = ["disabled"];
const _hoisted_110 = /*#__PURE__*/ _createElementVNode("small", { class: "helper-abaixo-input" }, [
    /*#__PURE__*/ _createTextVNode(" Ex: "),
    /*#__PURE__*/ _createElementVNode("span", {
        class: "text-danger",
        style: { "text-decoration": "line-through" }
    }, " 123456 "),
    /*#__PURE__*/ _createElementVNode("b", null, "-2")
], -1);
const _hoisted_111 = { class: "row" };
const _hoisted_112 = { class: "col-6 hide" };
const _hoisted_113 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Tipo de Conta", -1);
const _hoisted_114 = ["disabled"];
const _hoisted_115 = /*#__PURE__*/ _createElementVNode("option", { value: "" }, null, -1);
const _hoisted_116 = /*#__PURE__*/ _createElementVNode("option", { value: "cc" }, "Corrente", -1);
const _hoisted_117 = /*#__PURE__*/ _createElementVNode("option", { value: "cp" }, "Poupança", -1);
const _hoisted_118 = [
    _hoisted_115,
    _hoisted_116,
    _hoisted_117
];
const _hoisted_119 = { class: "col-6 hide" };
const _hoisted_120 = /*#__PURE__*/ _createElementVNode("label", null, [
    /*#__PURE__*/ _createTextVNode("Nr. Operação "),
    /*#__PURE__*/ _createElementVNode("small", null, "(Se houver)")
], -1);
const _hoisted_121 = ["disabled"];
const _hoisted_122 = /*#__PURE__*/ _createElementVNode("option", { value: "" }, null, -1);
const _hoisted_123 = ["value"];
const _hoisted_124 = ["disabled"];
const _hoisted_125 = {
    key: 0,
    class: "fa fa-spinner fa-spin fa-1x fa-fw"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DocumentoInput = _resolveComponent("DocumentoInput");
    const _component_DatetimePicker = _resolveComponent("DatetimePicker");
    const _component_ModalEdicaoMeuPerfilEndereco = _resolveComponent("ModalEdicaoMeuPerfilEndereco");
    const _component_AutocompleteGenerico = _resolveComponent("AutocompleteGenerico");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.titulo), 1),
                            (_ctx.secao == 'dados-bancarios')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _hoisted_11
                ]),
                _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("form", {
                        method: "post",
                        onSubmit: _cache[27] || (_cache[27] = ($event) => (_ctx.salvar($event))),
                        autocomplete: "false"
                    }, [
                        _hoisted_13,
                        (_ctx.secao == 'dados-pessoais')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, [
                                        _createElementVNode("div", _hoisted_17, [
                                            _hoisted_18,
                                            _withDirectives(_createElementVNode("select", {
                                                class: "form-control",
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.user.tipo) = $event)),
                                                onChange: _cache[1] || (_cache[1] = ($event) => (_ctx.changeTipoConta())),
                                                required: "",
                                                disabled: ""
                                            }, _hoisted_22, 544), [
                                                [_vModelSelect, _ctx.user.tipo]
                                            ])
                                        ])
                                    ])
                                ]),
                                (_ctx.user.tipo == 'F')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                        _createElementVNode("div", _hoisted_24, [
                                            _createElementVNode("div", _hoisted_25, [
                                                _hoisted_26,
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.user.name) = $event)),
                                                    required: "",
                                                    placeholder: "Nome",
                                                    disabled: !_ctx.podeAlterar
                                                }, null, 8, _hoisted_27), [
                                                    [_vModelText, _ctx.user.name]
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_28, [
                                            _createElementVNode("div", _hoisted_29, [
                                                _hoisted_30,
                                                _createVNode(_component_DocumentoInput, {
                                                    modelValue: _ctx.user.cpf_cnpj,
                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.user.cpf_cnpj) = $event)),
                                                    tipo: "cpf",
                                                    required: "",
                                                    placeholder: "CPF",
                                                    disabled: Boolean(!_ctx.podeAlterar ||
                                                        (_ctx.userMaster.tipo == 'F' && _ctx.userMaster.cpf_cnpj))
                                                }, null, 8, ["modelValue", "disabled"])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_31, [
                                            _createElementVNode("div", _hoisted_32, [
                                                _hoisted_33,
                                                _createElementVNode("div", _hoisted_34, [
                                                    _createVNode(_component_DatetimePicker, {
                                                        modelValue: _ctx.user.data_nascimento,
                                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.user.data_nascimento) = $event)),
                                                        config: { format: 'DD/MM/YYYY' },
                                                        disabled: !_ctx.podeAlterar
                                                    }, null, 8, ["modelValue", "disabled"])
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_35, [
                                            _createElementVNode("div", _hoisted_36, [
                                                _hoisted_37,
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    required: "",
                                                    placeholder: "Celular",
                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.user.celular) = $event)),
                                                    mask: "(99) 9999?9-9999"
                                                }, null, 512), [
                                                    [_vModelText, _ctx.user.celular]
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", null, [
                                            _createElementVNode("div", _hoisted_38, [
                                                _createElementVNode("div", _hoisted_39, [
                                                    _hoisted_40,
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        class: "form-control",
                                                        required: "",
                                                        placeholder: "Acesso ao Sistema",
                                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.user.email) = $event)),
                                                        uncapitalize: ""
                                                    }, null, 512), [
                                                        [_vModelText, _ctx.user.email]
                                                    ])
                                                ])
                                            ]),
                                            _hoisted_41
                                        ]),
                                        _createElementVNode("div", null, [
                                            _createElementVNode("div", _hoisted_42, [
                                                _createVNode(_component_ModalEdicaoMeuPerfilEndereco, {
                                                    user: _ctx.user,
                                                    podeAlterar: _ctx.podeAlterar
                                                }, null, 8, ["user", "podeAlterar"]),
                                                _createElementVNode("div", _hoisted_43, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        id: "aceita_receber_emails_marketing",
                                                        name: "aceita_receber_emails_marketing",
                                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.user.aceita_receber_emails_marketing) = $event)),
                                                        "true-value": true,
                                                        class: "custom-control-input",
                                                        type: "checkbox"
                                                    }, null, 512), [
                                                        [_vModelCheckbox, _ctx.user.aceita_receber_emails_marketing]
                                                    ]),
                                                    _hoisted_44
                                                ])
                                            ])
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                (_ctx.user.tipo == 'J')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                        _createElementVNode("div", _hoisted_46, [
                                            _createElementVNode("div", _hoisted_47, [
                                                _hoisted_48,
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.user.name) = $event)),
                                                    required: "",
                                                    placeholder: "Nome Fantasia",
                                                    disabled: !_ctx.podeAlterar
                                                }, null, 8, _hoisted_49), [
                                                    [_vModelText, _ctx.user.name]
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_50, [
                                            _createElementVNode("div", _hoisted_51, [
                                                _hoisted_52,
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.user.razao_social) = $event)),
                                                    required: "",
                                                    placeholder: "Razão Social",
                                                    disabled: !_ctx.podeAlterar
                                                }, null, 8, _hoisted_53), [
                                                    [_vModelText, _ctx.user.razao_social]
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_54, [
                                            _createElementVNode("div", _hoisted_55, [
                                                _hoisted_56,
                                                _createVNode(_component_DocumentoInput, {
                                                    modelValue: _ctx.user.cpf_cnpj,
                                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.user.cpf_cnpj) = $event)),
                                                    tipo: "cnpj",
                                                    required: "",
                                                    placeholder: "CNPJ",
                                                    disabled: Boolean(_ctx.userMaster.tipo == 'J' && _ctx.userMaster.cpf_cnpj)
                                                }, null, 8, ["modelValue", "disabled"])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_57, [
                                            _createElementVNode("div", _hoisted_58, [
                                                _hoisted_59,
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.user.inscricao_estadual) = $event)),
                                                    placeholder: "Inscrição Estadual",
                                                    format: "integer",
                                                    disabled: !_ctx.podeAlterar
                                                }, null, 8, _hoisted_60), [
                                                    [_vModelText, _ctx.user.inscricao_estadual]
                                                ])
                                            ])
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                (_ctx.user.tipo == 'J')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                        _hoisted_62,
                                        _createElementVNode("div", _hoisted_63, [
                                            _createElementVNode("div", _hoisted_64, [
                                                _hoisted_65,
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.user.responsavel_nome) = $event)),
                                                    required: "",
                                                    placeholder: "Nome completo do responsável pela empresa",
                                                    disabled: Boolean(!_ctx.podeAlterar ||
                                                        (_ctx.userMaster.tipo == 'J' &&
                                                            _ctx.userMaster.responsavel_nome))
                                                }, null, 8, _hoisted_66), [
                                                    [_vModelText, _ctx.user.responsavel_nome]
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_67, [
                                            _createElementVNode("div", _hoisted_68, [
                                                _hoisted_69,
                                                _createVNode(_component_DocumentoInput, {
                                                    modelValue: _ctx.user.responsavel_cpf,
                                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.user.responsavel_cpf) = $event)),
                                                    tipo: "cpf",
                                                    required: "",
                                                    placeholder: "CPF do responsável pela empresa",
                                                    disabled: Boolean(!_ctx.podeAlterar ||
                                                        (_ctx.userMaster.tipo == 'J' &&
                                                            _ctx.userMaster.responsavel_cpf))
                                                }, null, 8, ["modelValue", "disabled"])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_70, [
                                            _createElementVNode("div", _hoisted_71, [
                                                _hoisted_72,
                                                _createElementVNode("div", _hoisted_73, [
                                                    _createVNode(_component_DatetimePicker, {
                                                        modelValue: _ctx.user.data_nascimento,
                                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_ctx.user.data_nascimento) = $event)),
                                                        config: { format: 'DD/MM/YYYY' },
                                                        disabled: !_ctx.podeAlterar
                                                    }, null, 8, ["modelValue", "disabled"])
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_74, [
                                            _createElementVNode("div", _hoisted_75, [
                                                _hoisted_76,
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    required: "",
                                                    placeholder: "Celular",
                                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_ctx.user.celular) = $event)),
                                                    mask: "(99) 9999?9-9999"
                                                }, null, 512), [
                                                    [_vModelText, _ctx.user.celular]
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", null, [
                                            _createElementVNode("div", _hoisted_77, [
                                                _createElementVNode("div", _hoisted_78, [
                                                    _hoisted_79,
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        class: "form-control",
                                                        required: "",
                                                        placeholder: "Acesso ao Sistema",
                                                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_ctx.user.email) = $event)),
                                                        uncapitalize: ""
                                                    }, null, 512), [
                                                        [_vModelText, _ctx.user.email]
                                                    ])
                                                ])
                                            ]),
                                            _hoisted_80,
                                            _createElementVNode("div", _hoisted_81, [
                                                _createVNode(_component_ModalEdicaoMeuPerfilEndereco, {
                                                    user: _ctx.user,
                                                    podeAlterar: _ctx.podeAlterar
                                                }, null, 8, ["user", "podeAlterar"]),
                                                _createElementVNode("div", _hoisted_82, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        id: "aceita_receber_emails_marketing",
                                                        name: "aceita_receber_emails_marketing",
                                                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_ctx.user.aceita_receber_emails_marketing) = $event)),
                                                        class: "custom-control-input",
                                                        type: "checkbox"
                                                    }, null, 512), [
                                                        [_vModelCheckbox, _ctx.user.aceita_receber_emails_marketing]
                                                    ]),
                                                    _hoisted_83
                                                ])
                                            ])
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true),
                        (_ctx.secao == 'dados-bancarios')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                _createElementVNode("span", _hoisted_85, [
                                    _hoisted_86,
                                    _createTextVNode(" Informe uma conta corrente vinculada ao " + _toDisplayString(_ctx.user.tipo === "F" ? "CPF" : "CNPJ") + " cadastrado. ", 1)
                                ]),
                                _hoisted_87,
                                _hoisted_88,
                                _createElementVNode("div", _hoisted_89, [
                                    _createElementVNode("div", _hoisted_90, [
                                        _hoisted_91,
                                        _createElementVNode("div", _hoisted_92, [
                                            _createVNode(_component_AutocompleteGenerico, {
                                                modelValue: _ctx.user.banco_id,
                                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((_ctx.user.banco_id) = $event)),
                                                url: "/bancos/autocomplete",
                                                "text-alias": "nome",
                                                "concatenar-id-text": true,
                                                placeholder: " ",
                                                required: "",
                                                disabled: !_ctx.podeAlterar
                                            }, null, 8, ["modelValue", "disabled"])
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_93, [
                                    _createElementVNode("div", _hoisted_94, [
                                        _hoisted_95,
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((_ctx.user.agencia) = $event)),
                                            disabled: !_ctx.podeAlterar,
                                            minlength: "3",
                                            maxlength: "4"
                                        }, null, 8, _hoisted_96), [
                                            [_vModelText, _ctx.user.agencia]
                                        ]),
                                        _hoisted_97
                                    ]),
                                    _createElementVNode("div", _hoisted_98, [
                                        _hoisted_99,
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            onChange: _cache[20] || (_cache[20] = ($event) => (_ctx.forcarDigitoNumericoAg())),
                                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((_ctx.user.agencia_dv) = $event)),
                                            placeholder: "Se houver",
                                            disabled: !_ctx.podeAlterar,
                                            maxlength: "1"
                                        }, null, 40, _hoisted_100), [
                                            [_vModelText, _ctx.user.agencia_dv]
                                        ]),
                                        _hoisted_101
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_102, [
                                    _createElementVNode("div", _hoisted_103, [
                                        _hoisted_104,
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((_ctx.user.conta) = $event)),
                                            disabled: !_ctx.podeAlterar,
                                            maxlength: "50"
                                        }, null, 8, _hoisted_105), [
                                            [_vModelText, _ctx.user.conta]
                                        ]),
                                        _hoisted_106
                                    ]),
                                    _createElementVNode("div", _hoisted_107, [
                                        _hoisted_108,
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            onChange: _cache[23] || (_cache[23] = ($event) => (_ctx.forcarDigitoNumericoConta())),
                                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => ((_ctx.user.conta_dv) = $event)),
                                            disabled: !_ctx.podeAlterar,
                                            maxlength: "1"
                                        }, null, 40, _hoisted_109), [
                                            [_vModelText, _ctx.user.conta_dv]
                                        ]),
                                        _hoisted_110
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_111, [
                                    _createElementVNode("div", _hoisted_112, [
                                        _hoisted_113,
                                        _withDirectives(_createElementVNode("select", {
                                            class: "form-control",
                                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => ((_ctx.user.conta_tipo) = $event)),
                                            disabled: !_ctx.podeAlterar
                                        }, _hoisted_118, 8, _hoisted_114), [
                                            [_vModelSelect, _ctx.user.conta_tipo]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_119, [
                                        _hoisted_120,
                                        _withDirectives(_createElementVNode("select", {
                                            class: "form-control",
                                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => ((_ctx.user.conta_operacao) = $event)),
                                            disabled: !_ctx.podeAlterar
                                        }, [
                                            _hoisted_122,
                                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['1288', '3701', '001', '002', '003', '013', '022', '023', '037'], (x) => {
                                                return _createElementVNode("option", { value: x }, _toDisplayString(x), 9, _hoisted_123);
                                            }), 64))
                                        ], 8, _hoisted_121), [
                                            [_vModelSelect, _ctx.user.conta_operacao]
                                        ])
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("button", {
                            class: "btn btn-primary btn-block mt-2",
                            type: "submit",
                            disabled: _ctx.isSaving
                        }, [
                            _createTextVNode(" Salvar "),
                            (_ctx.isSaving)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_125))
                                : _createCommentVNode("", true)
                        ], 8, _hoisted_124)
                    ], 32)
                ])
            ])
        ])
    ]));
}
